export const getBundles = (state) => state.bundles
export const getBundle = (state) => (hash_id) => { return state.bundles.filter((bundle) => { return bundle.hash_id == hash_id })[0] }
export const getBundleApplyEnum = (state) => state.applies
export const getBundleTypeEnum = (state) => state.types
